"use client";

import { useEffect } from "react";
import { FONT_SCALE_PX, useFontScaleStore } from "@/stores/font-scale-store";

/**
 * 글자 크기 적용기 (렌더링 없음)
 *
 * Zustand persist 스토어의 fontScale 값을 구독해
 * html 루트의 font-size(px)를 설정합니다.
 * Tailwind의 rem 기반 유틸리티가 모두 비율로 스케일됩니다.
 *
 * 첫 페인트 깜빡임은 app/layout.tsx 의 인라인 스크립트가 방지하며,
 * 이 컴포넌트는 하이드레이션 이후의 변경 사항을 반영합니다.
 */
export function FontScaleApplier(): null {
  const fontScale = useFontScaleStore((state) => state.fontScale);

  useEffect(() => {
    document.documentElement.style.fontSize = `${FONT_SCALE_PX[fontScale]}px`;
  }, [fontScale]);

  return null;
}
